import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../Button';
import { MobileContext } from '../../Context';
import baseConfirmationPopupStyles from './BaseConfirmationPopup.scss';
export var ConfirmationPopupFooter = function (_a) {
    var onCancel = _a.onCancel, onDone = _a.onDone, withCancelButton = _a.withCancelButton, cancelButtonLabel = _a.cancelButtonLabel, cancelButtonBiData = _a.cancelButtonBiData, confirmButtonLabel = _a.confirmButtonLabel, confirmButtonType = _a.confirmButtonType, confirmDisabled = _a.confirmDisabled, confirmButtonBiData = _a.confirmButtonBiData;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var confirmButtonView = isMobile ? 'b1' : 'b1-1';
    switch (confirmButtonType) {
        case 'danger':
            confirmButtonView = 'b14-4';
            break;
        case 'dark':
            confirmButtonView = 'b14-2';
            break;
        default:
    }
    return (React.createElement(React.Fragment, null,
        withCancelButton && (React.createElement(Button, { height: "medium", onClick: onCancel, view: isMobile ? 'b2' : 'b31', className: baseConfirmationPopupStyles['footer-btn'], biData: cancelButtonBiData }, cancelButtonLabel || t('popup.cancel'))),
        React.createElement(Button, { height: "medium", onClick: onDone, view: confirmButtonView, disabled: confirmDisabled, className: baseConfirmationPopupStyles['footer-btn'], biData: confirmButtonBiData }, confirmButtonLabel || t('popup.confirm'))));
};
ConfirmationPopupFooter.displayName = 'ConfirmationPopupFooter';
export default ConfirmationPopupFooter;
//# sourceMappingURL=ConfirmationPopupFooter.js.map